export const ENTERPRISE_VALUE = (equityValue, cash, debt) => equityValue - cash + debt;

export const EQUITY_VALUE = (enterpriseValue, cash, debt) => enterpriseValue + cash - debt;

export const getEnterpriseValueFormula = (enterpriseValue, cash, debt) =>
  `ENTERPRISE_VALUE(${enterpriseValue}, ${cash}, ${debt})`;

export const getEquityValueFormula = (equityValue, cash, debt) => `EQUITY_VALUE(${equityValue}, ${cash}, ${debt})`;
